// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3KpUi","inputWrap":"Table_inputWrap__30Wpt","col":"Table_col__10CI3","bmiTooltip":"Table_bmiTooltip__2sd75"};